import editIsLoading from './editIsLoading';

const settingsSelectors = {
  editIsLoading,
};

export default settingsSelectors;
